import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconClose = forwardRef<SVGSVGElement, IconProps>(
  function IconClose(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-6 h-6 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 24 24"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M20.5059 19.9306C20.5436 19.9684 20.5736 20.0132 20.594 20.0625C20.6145 20.1119 20.625 20.1648 20.625 20.2182C20.625 20.2716 20.6145 20.3245 20.594 20.3739C20.5736 20.4232 20.5436 20.4681 20.5059 20.5059C20.4681 20.5436 20.4232 20.5736 20.3739 20.594C20.3245 20.6145 20.2716 20.625 20.2182 20.625C20.1648 20.625 20.1119 20.6145 20.0625 20.594C20.0132 20.5736 19.9684 20.5436 19.9306 20.5059L12 12.5821L4.06942 20.5059C3.99313 20.5821 3.88967 20.625 3.78178 20.625C3.6739 20.625 3.57043 20.5821 3.49414 20.5059C3.41786 20.4296 3.375 20.3261 3.375 20.2182C3.375 20.1103 3.41786 20.0069 3.49414 19.9306L11.4179 12L3.49414 4.06942C3.41786 3.99313 3.375 3.88967 3.375 3.78178C3.375 3.6739 3.41786 3.57043 3.49414 3.49414C3.57043 3.41786 3.6739 3.375 3.78178 3.375C3.88967 3.375 3.99313 3.41786 4.06942 3.49414L12 11.4179L19.9306 3.49414C20.0069 3.41786 20.1103 3.375 20.2182 3.375C20.3261 3.375 20.4296 3.41786 20.5059 3.49414C20.5821 3.57043 20.625 3.6739 20.625 3.78178C20.625 3.88967 20.5821 3.99313 20.5059 4.06942L12.5821 12L20.5059 19.9306Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
